import { cartApi } from "@monorepo/services/api/carts";
import { createListenerMiddleware } from "@reduxjs/toolkit";

import { setHistoricalMode } from "./historicalPayment";

export const historicalCartListener = createListenerMiddleware();

historicalCartListener.startListening({
  actionCreator: setHistoricalMode,
  effect: (_, api) => {
    api.dispatch(cartApi.util.invalidateTags(["Carts", "CartGroup", "CartGroupById"]));
  },
});
